export const API:string = 'https://api.fanyi.baidu.com/api/trans/vip/translate?';
export const APP_ID:string  = "20180416000147222"; //这里修改APP_ID
export const APP_KEY:string  = "IvlTe9ogsiBHl9Muevzu";//这里修改APP_KEY